@if (_isToggleRow()) {
  <div class="cads-menu-row-item cads-menu-row-item--toggle" [class.cads-menu-row-item--compact]="_isCompact()">
    <div class="cads-menu-row-item__row">
      @if (config().menuRowLeading; as leading) {
        <div class="cads-menu-row-item__leading" aria-hidden="true">
          <cads-icon-view-bit [config]="leading.config" />
        </div>
      }
      <div class="cads-menu-row-item__heading">
        <cads-heading-detail-bit [config]="config().menuRowHeading" />
      </div>
      <button
        type="button"
        class="cads-menu-row-item__switch"
        role="switch"
        [attr.aria-checked]="_toggleIsOn()"
        [attr.aria-label]="_switchAriaLabel()"
        [attr.aria-busy]="_toggleProcessing() ? true : null"
        [disabled]="_toggleProcessing()"
        (click)="_onToggleClick($event)"
      >
        @if (_toggleProcessing()) {
          <span class="cads-menu-row-item__switch-spinner" aria-hidden="true">
            <cads-processing-spinner [config]="toggleProcessingSpinnerConfig()" />
          </span>
        } @else {
          <cads-icon-view-bit [config]="toggleGlyphBitConfig()" />
        }
      </button>
    </div>
  </div>
} @else {
  <div
    class="cads-menu-row-item"
    [class.cads-menu-row-item--compact]="_isCompact()"
    [class.cads-menu-row-item--tappable]="_isTappableRow()"
    [class.cads-menu-row-item--static]="_isStaticRow()"
    [attr.role]="_isTappableRow() ? 'button' : null"
    [attr.tabindex]="_isTappableRow() ? 0 : null"
    (click)="_onTappableActivate()"
    (keydown)="_onTappableKeydown($event)"
    (keyup)="_onTappableKeyup($event)"
  >
    <div class="cads-menu-row-item__row">
      @if (config().menuRowLeading; as leading) {
        <div class="cads-menu-row-item__leading" aria-hidden="true">
          <cads-icon-view-bit [config]="leading.config" />
        </div>
      }
      <div class="cads-menu-row-item__heading">
        <cads-heading-detail-bit [config]="config().menuRowHeading" />
      </div>
      <div class="cads-menu-row-item__trailing">
        @switch (config().menuRowTrailing.kind) {
          @case ('chevron') {
            <cads-icon-view-bit [config]="trailingChevronBitConfig()" />
          }
          @case ('textWithChevron') {
            <span class="cads-menu-row-item__trailing-text">{{ textWithChevronLabel() }}</span>
            <cads-icon-view-bit [config]="trailingChevronBitConfig()" />
          }
          @case ('text') {
            <span class="cads-menu-row-item__trailing-text">{{ staticTrailingText() }}</span>
          }
          @case ('compact') {
            <span class="cads-menu-row-item__trailing--none" aria-hidden="true"></span>
          }
        }
      </div>
    </div>
  </div>
}
